module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "calculatorsList",
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.nonEmptyCalculators.length == 0) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("No calculators have been setup for this quote.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.nonEmptyCalculators), function(link, index) {
    return _c('v-flex', {
      attrs: {
        "lg3": ""
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "80%",
        "border-radius": "5px"
      },
      attrs: {
        "src": require("../../../assets/calculators.jpg")
      }
    }), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.fncGoLink(_vm.globalModalParams.links[index].link)
        }
      }
    }, [_vm._v(_vm._s(_vm.globalModalParams.links[index].name))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 2)], 1)
},staticRenderFns: []}